import React from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from "@/ui";
import client from '@/store/client';

import './style.scss';

const ExampleItem = observer(({ data = {}, scene = "", className }) => {
  const isAgentLandingPage = scene == 'agent_landing_page';

  const dmImage = (url = "") => {
    let ret = ""

    if(url) {
      try {
        const obj = new URL(url)
        ret = obj.protocol + "//" + obj.host + "/dm/496_284_100" + obj.pathname
      } catch (error) {}
    }

    return ret
  }

  return (
    <div className={[
      'example-item',
      isAgentLandingPage ? 'w-148px h-170px' : 'w-250px h-235px',
      "box-border rounded-12px border-1px bg-white",
      "border-black border-opacity-16 overflow-hidden group"
    ]}>
      <div className={[
        'w-full relative overflow-hidden',
        isAgentLandingPage ? 'h-83px' : 'h-142px'
      ]}>
        {
          data?.is_have_cover == 1 
          ? (
            <div 
              className={[
                'size-full px-12px box-border',
                isAgentLandingPage ? 'py-12px' : '!p-16px '
              ]}
              style={{
                backgroundColor: data?.cover
              }}
            >
              <SVGPureIcon 
                name='example-item-quotation'
                className={[
                  "size-24px",
                  isAgentLandingPage ? "size-14px" : ""
                ]}
              />
              <div 
                className={[
                  isAgentLandingPage ? 'leading-20px text-14px mt-4px line-clamp-2' : 'mt-8px leading-24px text-16px line-clamp-3',
                  ' text-black text-opacity-70',
                ]}
              >
                { data?.query || "" }
              </div>
            </div>
          )
          : null
        }
        {
          data?.is_have_cover != 1
          ? (
            <div 
              className='size-full bg-cover'
              style={{
                backgroundImage: `url(${dmImage(data?.cover)})`,
                backgroundPosition: 'center center',
                backgroundSize: "100% 100%"
              }}
            />
          )
          : null
        }
        <div 
          className={[
            "absolute -bottom-142px left-0 size-full bg-black bg-opacity-30",
            "flex flex-col items-center justify-center ",
            isAgentLandingPage ? 'gap-7px' : 'gap-12px',
            "group-hover:bottom-0 transition-bottom duration-200 ease-in-out"
          ]}
          style={{
            backdropFilter: "blur(8px)"
          }}
        >
          <div
            className={[
              'bg-white rounded-full cursor-pointer flex items-center justify-center gap-8px hover:bg-[#f7f7f7]',
              isAgentLandingPage ? 'w-124px h-28px' : 'w-218px h-32px'
            ]}
            onClick={() => {
              client.openPage(`/share/mcp?id=${data?.share_id}&type=result`)
            }}
          >
            <SVGPureIcon
              name='example-item-check'
              className='size-16px'
            />
            <div className={[
              isAgentLandingPage ? 'text-13px' : 'text-14px',
              'text-black'
            ]}>查看作品</div>
          </div>
          <div
            className={[
              'bg-black rounded-full cursor-pointer flex items-center justify-center gap-8px hover:bg-[#333]',
              isAgentLandingPage ? 'w-124px h-28px' : 'w-218px h-32px'
            ]}
            onClick={() => {
              client.openPage(`/share/mcp?id=${data?.share_id}`)
            }}
          >
            <SVGPureIcon
              name='example-item-task'
              className='size-16px text-white'
            />
            <div 
              className={[
                isAgentLandingPage ? 'text-13px' : 'text-14px',
                'text-white'
              ]}
            >任务详情</div>
          </div>
        </div>
      </div>
      <div className={[
        'w-full mt-12px',
        isAgentLandingPage ? 'px-12px ' : 'px-16px'
      ]}>
        <div className={[
          'text-14px text-black line-clamp-2',
          isAgentLandingPage ? 'h-40px leading-20px mb-4px' : 'h-44px leading-22px mb-8px'
        ]}>
          { data?.title || "" }
        </div>
        <div className='text-12px text-black text-opacity-50 leading-20px line-clamp-1'>
          {data?.creator ? "@ " + data?.creator : ""}
        </div>
      </div>
    </div>
  )
})

export default ExampleItem